$.fn.extend
  photoContainer: (options) ->
    input = 
      option1: "red"
    
    input = $.extend input, options

    # console.log settings.frames

    container = $(@)

    $('#show_external_upload').click ->
      $('#external_upload_overlay').toggleClass 'shown'
      # $('#external_upload').toggleClass 'shown'
      return false

    $('#external_upload_done').click ->
      $('#external_upload_overlay').removeClass 'shown'
      output.reload()
      return false
    

    $('#show_upload_dialog').click ->
      $('#upload_dialog').toggleClass 'shown'
      return false

    output = {
    

        reload: () ->
            if $('input#hide_used').is(":checked")
              hide_used = true
            else hide_used = false

            if $('input#show_all_photos').is(":checked")
              show_all_photos = true
            else show_all_photos = false            

            if $('input#show_friends_photos').is(":checked")
              show_friends_photos = true
            else show_friends_photos = false  

            showSmallLoader()
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              url: '/ajax/app/photo_container/'
              data:
                app_url:window.location.pathname
                hide_used: hide_used
                show_all_photos: show_all_photos
                show_friends_photos: show_friends_photos
                ordering: $('select#photo_ordering').val()
            ).done((data) ->
                hideSmallLoader()

                console.log data
                container.html data.html_output

                if data.photos_qty == 0
                  $('#dropzone_main').addClass 'empty'
                  $('#autofill').addClass 'hidden'
                else
                  $('#dropzone_main').removeClass 'empty'
                  $('#autofill').removeClass 'hidden'


                # if $('.photo').length
                #   $("#hide_used_cont").removeClass 'hidden'
                #   $("#photo_ordering_cont").removeClass 'hidden'

                container.find('.photo').each ->

                    photo = $(@)
                    photo.appObject
                      dropTarget: '.frame, .createNewPage'
                      afterDrop: (dropFrame) ->
                        new_frame = dropFrame.frameEvents()
                        console.log dropFrame
                        console.log new_frame
                        new_frame.insert(photo.data('filename'))



                # $('.scrollbar').scrollbar();



            ).fail (jqXHR, textStatus) ->
              console.warn 'Error: ' + jqXHR.responseText
              return
            return 


            

    }

    # output.reload()

    return output